// extracted by mini-css-extract-plugin
var _1 = "lFPhz";
export { _1 as "base" }
